import { BaseClient } from '@hpx-it/base-client';

export class ManualAuthBaseClient extends BaseClient {
  constructor(apiUrl: string, authToken: string) {
    super(apiUrl, async () => Promise.resolve({ authorization: authToken }));
  }
}
